import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    dependencias: [],
  },

  getters: {
    getDependencias: (state) => state.dependencias,
  },

  mutations: {
    SET_DEPENDENCIAS(state, dependencias) {
      state.dependencias = dependencias;
    },
  },

  actions: {
    async fetchDependencias({ commit }) {
      await axios
        .get('/EonCloud/common/dependencias')
        .then((response) => {
          commit('SET_DEPENDENCIAS', response.data.data);
        });
    },
  },
};
